import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Col,
  Form,
  Form as FormInitial,
  message,
  Row,
  Space,
  Select,
} from "antd";
import FormItem from "antd/lib/form/FormItem";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { ButtonItem, InputItem, ModalItem } from "../../../../Components/Items";

const { Option } = Select;

class ModalPdfLista extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    pdfUrl: null,
    error: null,
    nivelPrecioId: null,
    empresaPrecios: [],
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && this.props.visible !== prevProps.visible) {
      this.cargarNivelesYPdf();
    }
  }

  cargarNivelesYPdf = async () => {
    this.setState({ loading: true, pdfUrl: null, error: null });
    try {
      const res = await axios.post(
        "listasEscuela/empresaPreciosParaPdfLista",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      );
      const niveles =
        res.data.success === 2 ? res.data.empresaPrecios || [] : [];
      const defaultNivel = niveles.length > 0 ? String(niveles[0]._id) : null;
      this.setState(
        { empresaPrecios: niveles, nivelPrecioId: defaultNivel },
        () => this.consultarPdf()
      );
    } catch (err) {
      console.error(err);
      this.setState({
        loading: false,
        error: "No se pudieron cargar los niveles de precio.",
      });
    }
  };

  componentWillUnmount() {
    this.revocarPdfUrl();
  }

  revocarPdfUrl() {
    if (this.state.pdfUrl) {
      URL.revokeObjectURL(this.state.pdfUrl);
    }
  }

  consultarPdf = async () => {
    if (!this.props.listaId) return;
    this.revocarPdfUrl();
    this.setState({ loading: true, pdfUrl: null, error: null });

    try {
      const res = await axios.post(
        "listasEscuela/verPdfListaEscuela",
        {
          empresaId: this.props.empresaId,
          listaId: this.props.listaId,
          nivelPrecioId: this.state.nivelPrecioId,
        },
        {
          headers: this.props.headersToken,
          responseType: "arraybuffer",
        }
      );

      const blob = new Blob([res.data], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      this.setState({ loading: false, pdfUrl: url });
    } catch (err) {
      console.error(err);
      this.setState({
        loading: false,
        error: "No se pudo cargar el PDF de la lista.",
      });
    }
  };

  cambiarNivelPrecio = (v) => {
    this.setState({ nivelPrecioId: v }, () => this.consultarPdf());
  };

  cerrarModal = () => {
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
    this.revocarPdfUrl();
    this.setState({ pdfUrl: null, error: null });
    this.props.onCancel();
  };

  onFinish = async (values) => {
    if (!values?.correosEnvio?.length) {
      message.info("Proporcione al menos un correo de envío");
      return;
    }

    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "listasEscuela/enviarListaEscuela",
        {
          empresaId: this.props.empresaId,
          listaId: this.props.listaId,
          nivelPrecioId: this.state.nivelPrecioId,
          correosEnvio: values.correosEnvio,
        },
        { headers: this.props.headersToken }
      );

      if (res.data.success === 2) {
        message.success("Lista enviada");
        this.cerrarModal();
      } else if (res.data.success === 1) {
        message.error(
          res.data.message || "No se pudo enviar a los correos indicados"
        );
      } else {
        message.error(
          res.data.message || "Sucedió un error y no se pudo enviar"
        );
      }
    } catch (err) {
      console.error(err);
      message.error("Ocurrió un error al enviar el correo. Intenta nuevamente.");
    } finally {
      this.setState({ loading: false });
    }
  };

  descargarPdf = () => {
    if (!this.state.pdfUrl) return;
    const a = document.createElement("a");
    a.href = this.state.pdfUrl;
    a.download = `Lista - ${this.props.nombreLista || "lista"}.pdf`.replace(
      /[\\/:*?"<>|]/g,
      ""
    );
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  render() {
    const niveles = this.state.empresaPrecios || [];

    return (
      <ModalItem
        title={`Lista de útiles${this.props.nombreLista ? " - " + this.props.nombreLista : ""}`}
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarModal}
        paddingTop
      >
        <Form
          ref={this.formRef}
          name="verEnviarListaPdf"
          layout
          width={700}
          onFinish={this.onFinish}
        >
          {niveles.length > 0 && (
            <FormItem label="Nivel de precio" margin>
              <Select
                value={this.state.nivelPrecioId}
                onChange={this.cambiarNivelPrecio}
                style={{ width: 280 }}
                placeholder="Selecciona un nivel de precio"
              >
                {niveles.map((p) => (
                  <Option key={String(p._id)} value={String(p._id)}>
                    {p.nombre}
                  </Option>
                ))}
              </Select>
            </FormItem>
          )}

          <FormInitial.List
            name="correosEnvio"
            initialValue={[{ correo: "" }]}
          >
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ name }, arrayKey) => (
                  <Row key={name}>
                    <Col span={22}>
                      <FormItem
                        name={[name, "correo"]}
                        fieldKey={[arrayKey, "correo"]}
                        label="Correo"
                        required
                        margin
                        email
                        pattern
                      >
                        <InputItem style={{ width: "100%" }} placeholder="Correo" />
                      </FormItem>
                    </Col>
                    <Col span={2}>
                      <div style={{ textAlign: "center" }}>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </div>
                    </Col>
                  </Row>
                ))}
                {fields.length < 5 ? (
                  <div style={{ textAlign: "center", marginTop: "5px" }}>
                    <ButtonItem
                      type="primary"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                    >
                      Agregar
                    </ButtonItem>
                  </div>
                ) : null}
              </>
            )}
          </FormInitial.List>

          <div
            style={{
              display: "flex",
              justifyContent: "right",
              marginTop: 20,
              marginBottom: 10,
            }}
          >
            <Space>
              <ButtonItem
                blanco
                onClick={this.descargarPdf}
                disabled={!this.state.pdfUrl}
              >
                Descargar PDF
              </ButtonItem>
              <ButtonItem
                type="primary"
                htmlType="submit"
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Mandar Correo
              </ButtonItem>
              <ButtonItem
                type="primary"
                danger
                onClick={this.cerrarModal}
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Cancelar
              </ButtonItem>
            </Space>
          </div>
        </Form>

        {this.state.error ? (
          <div style={{ color: "red", textAlign: "center" }}>
            {this.state.error}
          </div>
        ) : this.state.pdfUrl ? (
          <iframe
            title="Lista PDF"
            src={this.state.pdfUrl}
            style={{ width: "100%", height: "100vh", border: 0 }}
          />
        ) : null}
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalPdfLista);
